// imports react
import React, { useState } from "react";

//imports libraries
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import clsx from "clsx";
import axios from "axios";
import { toast } from "sonner";

//imports components
import styles from "../styles/login.module.css";

import { urlAPI_Current } from "../config";
import { LoginBaseBoard } from "../components/LoginBaseBoard";
import { LoginDivEVOK } from "../components/LoginDivEVOK";
import { SwitchMode } from "../components/SwitchMode";

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Formato de email incorreto")
    .min(3, "Minimo de 3 letras")
    .max(50, "Maxido de 50 letras")
    .required("Email é obrigatório"),
  password: Yup.string()
    .min(3, "Minimo de 3 letras")
    .max(50, "Maxido de 50 letras")
    .required("Senha atual é obrigatória"),
  newPassword: Yup.string()
    .min(3, "Minimo de 3 letras")
    .max(50, "Maxido de 50 letras")
    .required("Nova senha é obrigatória"),
  newPasswordConfirm: Yup.string()
    .min(3, "Minimo de 3 letras")
    .max(50, "Maxido de 50 letras")
    .required("Nova senha é obrigatória"),
});

const initialValues = {
  email: "",
};
export function ChangePassword() {
  const [isLoading, setIsLoading] = useState(false);

  const navigateTo = useNavigate();

  const [darkMode, setDarkMode] = useState(() => 
    window.localStorage.getItem('darkMode') === 'true'
  );

  const handleModeChange = (darkMode) => {
    setDarkMode(darkMode);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setIsLoading(true);

      console.log(values.newPassword);
      console.log(values.newPasswordConfirm);

      if (values.newPassword !== values.newPasswordConfirm) {
        toast.error("As novas senhas não iguais");
        setIsLoading(false);
        return;
      }
  
      try{
        const responseProfile = await axios.post(`${urlAPI_Current}/updatePasswordByEmail`,{
            email: values.email,
            password: values.password,
            newPassword: values.newPassword,
        }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        });
        
        if(responseProfile.data.success){
          toast.success("Senha trocada com sucesso!");
          navigateTo("/login");
        } else {
          toast.error("Senha atual não coincide");
        }
      }catch(err){
          console.log(err);
          toast.error("Senha atual não coincide");
      } finally {
        setIsLoading(false);
      }
    },
  });

  
  function navigateToLogin() {
    navigateTo("/login");
  }

  function navigateToTerms() {
    navigateTo("/");
  }

  function navigateToPlans() {
    navigateTo("/");
  }

  function navigateToContact() {
    navigateTo("/");
  }

  return (
    <div className={styles.container}>
      <div className="d-flex flex-column flex-root">
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
          <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
            <div className="d-flex flex-center flex-column flex-lg-row-fluid">
              <div className="w-sm-500px w-300px w-lg-500px p-10">
                <div className="text-center mb-11">
                  <SwitchMode onModeChange={handleModeChange}/>
                  <h1 className="text-gray-900 fw-bolder mb-3" data-bs-theme={darkMode ? ('dark') : ('light')}>
                    Trocar a senha
                  </h1>
                </div>

                <div className="separator separator-content my-14">
                  <span className="w-200px text-gray-500 fw-semibold fs-7" data-bs-theme={darkMode ? ('dark') : ('light')}>
                    Informe o seu email
                  </span>
                </div>

                <div className="fv-row mb-3" data-bs-theme={darkMode ? ('dark') : ('light')}>
                  <span className={styles.light}>
                    Insira as informações para trocar a senha:
                  </span>
                </div>

                <form
                  className="form w-100"
                  onSubmit={formik.handleSubmit}
                  noValidate
                  id="kt_login_signin_form"
                  data-bs-theme={darkMode ? ('dark') : ('light')}
                >
                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0" data-bs-theme={darkMode ? ('dark') : ('light')}>
                      Email
                    </label>
                    <input
                      placeholder="Email"
                      {...formik.getFieldProps("email")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.email && formik.errors.email,
                        },
                        {
                          "is-valid":
                            formik.touched.email && !formik.errors.email,
                        }
                      )}
                      type="email"
                      name="email"
                      autoComplete="off"
                      data-bs-theme={darkMode ? ('dark') : ('light')}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.email}</span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0 data-bs-theme={darkMode ? ('dark') : ('light')}">
                      Senha Atual
                    </label>
                    <input
                      placeholder="Senha Atual"
                      type="password"
                      autoComplete="current-password"
                      {...formik.getFieldProps("password")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.password && formik.errors.password,
                        },
                        {
                          "is-valid":
                            formik.touched.password && !formik.errors.password,
                        }
                      )}
                      data-bs-theme={darkMode ? ('dark') : ('light')}
                    />
                    {formik.touched.password && formik.errors.password && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.password}</span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0 data-bs-theme={darkMode ? ('dark') : ('light')}">
                      Nova Senha
                    </label>
                    <input
                      placeholder="Nova senha"
                      type="password"
                      autoComplete="current-password"
                      {...formik.getFieldProps("newPassword")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.newPassword && formik.errors.newPassword,
                        },
                        {
                          "is-valid":
                            formik.touched.newPassword && !formik.errors.newPassword,
                        }
                      )}
                      data-bs-theme={darkMode ? ('dark') : ('light')}
                    />
                    {formik.touched.newPassword && formik.errors.newPassword && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.newPassword}</span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0 data-bs-theme={darkMode ? ('dark') : ('light')}">
                      Confirme sua nova senha
                    </label>
                    <input
                      placeholder="Nova senha"
                      type="password"
                      autoComplete="current-password"
                      {...formik.getFieldProps("newPasswordConfirm")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.newPasswordConfirm && formik.errors.newPasswordConfirm,
                        },
                        {
                          "is-valid":
                            formik.touched.newPasswordConfirm && !formik.errors.newPasswordConfirm,
                        }
                      )}
                      data-bs-theme={darkMode ? ('dark') : ('light')}
                    />
                    {formik.touched.newPasswordConfirm && formik.errors.newPasswordConfirm && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.newPasswordConfirm}</span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="d-grid mb-10">
                    <button
                      type="submit"
                      id="kt_sign_in_submit"
                      className="btn btn-primary"
                      disabled={formik.isSubmitting || !formik.isValid}
                      data-bs-theme={darkMode ? ('dark') : ('light')}
                    >
                      {!isLoading && (
                        <span className="indicator-label" data-bs-theme={darkMode ? ('dark') : ('light')}>Trocar senha</span>
                      )}
                      {isLoading && (
                        <span
                          className="indicator-progress"
                          style={{ display: "block" }}
                        >
                          Carregando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      )}
                    </button>
                  </div>
                </form>

                <div className="text-gray-500 text-center fw-semibold fs-6">
                  Já possui uma conta?{" "}
                  <a onClick={() => navigateToLogin()} className="link-primary cursor-pointer">
                    Entrar
                  </a>
                </div>
              </div>
            </div>

            <LoginBaseBoard />
          </div>

          <LoginDivEVOK />
        </div>
      </div>
    </div>
  );
}
